import api from './api';
import { Solution } from '../types';

class SolutionService {
  async getSolutions(): Promise<Solution[]> {
    const response = await api.get('/solutions/');
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getSolution(id: number): Promise<Solution> {
    const response = await api.get(`/solutions/${id}/`);
    return response.data;
  }

  async createSolution(data: Partial<Solution>): Promise<Solution> {
    const response = await api.post('/solutions/', data);
    return response.data;
  }

  async updateSolution(id: number, data: Partial<Solution>): Promise<Solution> {
    const response = await api.patch(`/solutions/${id}/`, data);
    return response.data;
  }

  async deleteSolution(id: number): Promise<void> {
    await api.delete(`/solutions/${id}/`);
  }

  async uploadImage(solutionId: number, imageFile: File): Promise<any> {
    const formData = new FormData();
    formData.append('image', imageFile);
    formData.append('solution', solutionId.toString());

    const response = await api.post('/solution-images/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async reorderSolutions(items: Array<{ id: number; order: number; container?: number | null }>): Promise<void> {
    await api.post('/solutions/reorder/', { items });
  }

  async generatePatternValues(id: number): Promise<{ success: boolean; pattern_generated_values?: any; generated_values?: any; error?: string }> {
    const response = await api.post(`/solutions/${id}/generate_pattern_values/`);
    return response.data;
  }

  async generateSolutionValues(id: number): Promise<{ success: boolean; generated_values?: any; error?: string }> {
    const response = await api.post(`/solutions/${id}/generate_solution_values/`);
    return response.data;
  }

  async getAvailableSolutions(): Promise<Solution[]> {
    const response = await api.get('/solutions/available/');
    return response.data;
  }

  async getSolutionsByPattern(patternId: number): Promise<Solution[]> {
    const response = await api.get('/solutions/', {
      params: {
        pattern: patternId
      }
    });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }
}

const solutionService = new SolutionService();
export default solutionService;
